<template>
  <div class="pci-custom-cell-editor">
    <textarea
      ref="editor"
      class="ag-input-field-input ag-text-area-input"
      maxlength="32000"
      cols="80"
      rows="25"
      v-model="value"
      @keydown.enter.exact="handleEnterKey"
    />
  </div>
</template>

<script>
export default {
  data () {
    return {
      value: ''
    }
  },
  created () {
    this.value = this.params.value || ''

    if (this.params.charPress) {
      this.value += this.params.charPress
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.$refs.editor.focus()
    })
  },
  methods: {
    getValue () {
      return this.value
    },
    isCancelBeforeStart () {
      return false
    },
    handleEnterKey (event) {
      event.preventDefault()
      const selectionStart = event.target.selectionStart
      if (event.shiftKey || event.controlKey) {
        this.params.stopEditing()
        return
      }
      this.value = this.value.substring(0, event.target.selectionStart) + '\n' + this.value.substring(event.target.selectionEnd)
      event.stopPropagation()
      this.$nextTick(() => {
        event.target.setSelectionRange(selectionStart + 1, selectionStart + 1)
      })
    }
  }
}
</script>

<style scoped>
.pci-custom-cell-editor {
  border: 1px solid lightgray;
}
</style>



// WEBPACK FOOTER //
// src/views/private/operational/pci/components/PciCustomCellEditor.vue